import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const interestPreviewSerializeMap: SerializeMap<InterestPreviewData> = {
  id: "id",
  businessId: "business_id",
  calculationBasis: "calculation_basis",
  interestToChargeCents: "interest_to_charge_cents",
  chargeFromDate: "charge_from_date",
  chargeToDate: "charge_to_date",
  billingDocumentId: "billing_document_id",
  interestRate: "interest_rate",
  daysOfInterest: "days_of_interest",
  creditInterestRate: "credit_interest_rate",
  debitInterestRate: "debit_interest_rate",
  warnings: "warnings",
};

export const deserializeInterestPreview = buildDeserializer(
  interestPreviewSerializeMap,
  "interest preview",
);

export const serializeInterestPreview = buildSerializer(
  interestPreviewSerializeMap,
  "interest preview",
);
